/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const registeredTaxIDDataVerificationSchema = z.enum(['pending', 'unavailable', 'unverified', 'verified'])

export type RegisteredTaxIDDataVerificationSchema = z.infer<typeof registeredTaxIDDataVerificationSchema>
